/* eslint-disable */
import envGet from '../Get/EnvGet.support';

/**
 * Determine if we are in the `production` environment
 * @export
 * @returns {boolean} Whether or not we are in production
 */
const envIsProduction = () => envGet({ key: `REACT_APP_ENV` }) === `production`;

export default envIsProduction;
